import { useMutation, useQueryClient } from '@tanstack/react-query';
import { StatusCode } from 'status-code-enum';
import { postReactivateAccount } from './post-reactivate-account';

export function useReactivateAccount(options?: { onSuccess: () => void }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const res = await postReactivateAccount();
      if (res.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['Customers'] });
      if (options?.onSuccess) {
        options.onSuccess();
      }
    },
  });
}
